import lodashMerge from 'lodash/merge';
import queryString from 'query-string';

import {assertDependencies} from '../lib/util';
import withIE9Support from './jquery_ie9_support';

import TrackerEvent from '../audience_tracker/models/TrackerEvent';

const METHODS = {
	get: 'get',
	post: 'post'
};

const MANIFEST = require('./manifest');

const DEFAULT_OPTIONS = {
	base_url: 'https://example.org/'
};

function AudienceTrackerApi(options = DEFAULT_OPTIONS, deps = MANIFEST.dependencies) {
	const thisAudienceTrackerApi = this;

	options = lodashMerge({}, DEFAULT_OPTIONS, options);
	assertDependencies(MANIFEST.name, MANIFEST.dependencies, deps);

	const log = deps.logger.child(MANIFEST.name);
	const baseUrl = options.base_url[options.base_url.length - 1] === '/'
		? options.base_url.slice(0, -1)
		: options.base_url;

	let _requestId = 0;

	const jQuery = withIE9Support(deps.jQuery);

	Object.assign(thisAudienceTrackerApi, /** @lends AudienceTrackerApi.prototype */ {
		announce,
		sendEvent,
		sendActivity,
		base_url: baseUrl,
	});

	function request(method, endpoint, query, payload, callback) {
		_requestId++;
		const requestId = _requestId;

		const qs = query
			? '?' + queryString.stringify(query)
			: '';

		log.verbose(`[R_${requestId}] ${method} ${endpoint}${qs}`, payload);

		const settings = {
			method,
			url: baseUrl + endpoint + qs,
			contentType: 'application/json',
			accepts: 'json',
			crossDomain: true,
			data: payload
				? JSON.stringify(payload)
				: undefined,
			complete: onComplete
		};

		return jQuery.ajax(settings);

		function onComplete(jqXHR, textStatus) {
			const responseData = jqXHR.responseJSON || jqXHR.responseText || null;

			if (textStatus === 'success') {
				// Happy path
				return callback && callback(null, responseData);
			}

			let status = jqXHR.status;
			if (status === 0) {
				// OPTIONS response?
				status = 503;
				textStatus = 'Service unavailable';
			}

			const message = (responseData && responseData.error && responseData.error.message) || (responseData && responseData.message) || responseData || textStatus;
			const err = new ApiRequestError(status, message, responseData && responseData.error);
			log.error(`[R_${requestId}]`, err);
			err._logged = true;
			return callback && callback(err);
		}
	}

	function announce(msg, callback) {
		return request(METHODS.post, '/api/v1/tracker/announce', null, msg, callback);
	}

	function sendEvent(instanceId, eventMsg, callback) {
		if(Array.isArray(eventMsg) && eventMsg[0].event_type === TrackerEvent.TYPES.end_session) {
			return navigator.sendBeacon(`${baseUrl}/api/v1/tracker/${instanceId}/event`, JSON.stringify(eventMsg[0]));
		}

		return request(METHODS.post, `/api/v1/tracker/${instanceId}/event`, null, eventMsg, callback);
	}

	function sendActivity(instanceId, activityMsg, callback) {
		return request(METHODS.post, `/api/v1/tracker/${instanceId}/activity`, null, activityMsg, callback);
	}
}

// *********************************************************************************************************************

class ApiRequestError extends Error {
	constructor(message, code, payload) {
		super(`${message} (${code})`);
		this.code = code;
		this.original_error = payload;
		if (payload && payload.inner_error && payload.inner_error.errors) {
			this.errors = payload.inner_error.errors;
		}
	}
}

// *********************************************************************************************************************

export default AudienceTrackerApi;
